/**
 * Cinematic CloudFront video URLs used across the site. Centralising
 * them here keeps the section components clean and makes future swaps
 * (e.g. self-hosted MP4s, real footage) a one-file change.
 */
export const VIDEOS = {
  /** Hero - girl with orbital circles. Used on Home hero. */
  hero:        "https://d8j0ntlcm91z4.cloudfront.net/user_38xzZboKViGWJOttwIXH07lWA1P/hf_20260405_074625_a81f018a-956b-43fb-9aee-4d1508e30e6a.mp4",

  /** Blog hero - from v2 HTML design. */
  blogHero:    "https://d8j0ntlcm91z4.cloudfront.net/user_38xzZboKViGWJOttwIXH07lWA1P/hf_20260328_115001_bcdaa3b4-03de-47e7-ad63-ae3e392c32d4.mp4",

  /** Featured video - "Our approach" rounded video panel under About. */
  featured:    "https://d8j0ntlcm91z4.cloudfront.net/user_38xzZboKViGWJOttwIXH07lWA1P/hf_20260402_054547_9875cfc5-155a-4229-8ec8-b7ba7125cbf8.mp4",

  /** Philosophy / Defence × Velocity - left video tile. */
  philosophy:  "/videos/philosophy.mp4",

  /** Services - Strategy card. */
  serviceA:    "https://d8j0ntlcm91z4.cloudfront.net/user_38xzZboKViGWJOttwIXH07lWA1P/hf_20260314_131748_f2ca2a28-fed7-44c8-b9a9-bd9acdd5ec31.mp4",

  /** Services - Craft card / Submarines backdrop. */
  serviceB:    "https://d8j0ntlcm91z4.cloudfront.net/user_38xzZboKViGWJOttwIXH07lWA1P/hf_20260324_151826_c7218672-6e92-402c-9e45-f1e0f454bdc4.mp4",

  defence: "/videos/defence-command.mp4",

  submarine: "/videos/sub-underwater.mp4",

  mining: "/videos/mining-night.mp4",

  construction: "/videos/construction-golden.mp4",

  gis: "/videos/gis-terrain.mp4",

  machinery: "/videos/heavy-machinery.mp4",

  /** Defence × Resources tile - generated by Veo (run generate:newdefence) */
  defenceResources: "/videos/defence-resources.mp4",

  /** Defence × Velocity section backdrop - generated by Veo (run generate:newdefence) */
  defenceVelocity: "/videos/defence-velocity.mp4",

  /** Where we work - Auckland Sky Tower skyline */
  auckland: "/videos/auckland-city.mp4",

  /** Where we work - Perth CBD golden hour */
  perth: "/videos/perth-cbd.mp4",

  /** Where we work - Sydney Harbour Bridge at blue hour */
  sydney: "/videos/sydney-bridge.mp4",

  /** Data Analytics section backdrop - generated by Veo */
  dataAnalytics: "/videos/data-analytics.mp4",

  /** Subcontractor / welding backdrop - welding-pipes.mp4 unavailable; using defence-mining as nearest industrial substitute */
  weldingPipes: "/videos/defence-mining.mp4",

  /** Aitransformationconsultancy video — generated by Veo */
  aiTransformationConsultancy: "/videos/AITransformationConsultancy.mp4",
} as const;

/** Featured article image - used on Blog hero secondary card. */
export const BLOG_HERO_IMG = "/assets/blog-hero.png";

/**
 * Lightweight webp poster frames (one per video) generated by
 * `node scripts/generate-posters.mjs`. Posters paint instantly while the
 * matching video lazy-loads; the video then fades/plays in over the top.
 */
export const POSTERS = {
  hero:        "/videos/posters/hero.webp",
  blogHero:    "/videos/posters/blog-hero.webp",
  featured:    "/videos/posters/featured.webp",
  philosophy:  "/videos/posters/philosophy.webp",
  serviceA:    "/videos/posters/service-a.webp",
  serviceB:    "/videos/posters/service-b.webp",
  defence:     "/videos/posters/defence-command.webp",
  submarine:   "/videos/posters/sub-underwater.webp",
  mining:      "/videos/posters/mining-night.webp",
  construction:"/videos/posters/construction-golden.webp",
  gis:         "/videos/posters/gis-terrain.webp",
  machinery:   "/videos/posters/heavy-machinery.webp",
  defenceResources: "/videos/posters/defence-resources.webp",
  defenceVelocity:  "/videos/posters/defence-velocity.webp",
  auckland:    "/videos/posters/auckland-city.webp",
  perth:       "/videos/posters/perth-cbd.webp",
  sydney:      "/videos/posters/sydney-bridge.webp",
  dataAnalytics: "/videos/posters/data-analytics.webp",
  weldingPipes: "/videos/posters/defence-mining.webp",
  aiTransformationConsultancy: "/videos/posters/AITransformationConsultancy.webp",
} as const satisfies Record<keyof typeof VIDEOS, string>;
